export const GRAPH_REPORT_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    datalabels: {
      display: false,
    },
  },
  scales: {
    xAxes: [
      {
        gridLines: { display: false },
        ticks: { fontSize: 14 }
      }
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true
        },
        gridLines: { 
          display: true,
          color: 'transparent'
        },
        ticks: {
          fontSize: 15,
          beginAtZero: true
        },
      }
    ],
  },
  legend: {
    display: false
  }
};